import * as React from "react";
import {
  Avatar,
  Backdrop,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";

import DataGridComponent from "../components/DataGridComponent";
import { useNavigate } from "react-router-dom";
import { Circle } from "@mui/icons-material";
import { getAuth } from "firebase/auth";
import { useTheme } from "@emotion/react";
import { toast } from "react-toastify";
import NavBar from "../components/NavBar";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../config/firebase";

export default function MyReservations() {
  const { palette } = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [success, setSuccess] = React.useState(false);
  const [user, setUser] = React.useState(null);

  const columns = [
    {
      field: "checkIn",
      width: 200,
      headerName: "CheckIn",
      renderCell: (params) => {
        return <> {params.row.checkIn} </>;
      },
    },
    {
      field: "checkOut",
      width: 200,
      headerName: "CheckOut",
      renderCell: (params) => {
        return <> {params.row.checkOut} </>;
      },
    },
    {
      field: "guests",
      headerName: "Guests",
      width: 150,
      renderCell: (params) => {
        return <> {params.row.guests} </>;
      },
    },
    {
      field: "room",
      width: 200,
      headerName: "Room",
      renderCell: (params) => {
        return <> {params.row.room.name} </>;
      },
    },
    {
      field: "price",
      width: 200,
      headerName: "Price",
      renderCell: (params) => {
        return <> {params.row.price} </>;
      },
    },
    {
      field: "status",
      width: 200,
      headerName: "Payment Status",
      renderCell: (params) => {
        return (
          <>
            {" "}
            {params.row.status ? (
              <Circle sx={{ color: palette.success.main }} />
            ) : (
              <Circle
                sx={{
                  color: palette.error.main,
                }}
              />
            )}{" "}
          </>
        );
      },
    },
  ];

  const userInfo = getAuth().currentUser;

  const reservationsRef = collection(db, "reservations");
  const userRef = collection(db, `users`);

  React.useEffect(() => {
    if (userInfo && !userInfo.uid) {
      navigate("/", { replace: true });
    } else {
      async function fetchUser() {
        const u = await getDocs(userRef);
        setUser(
          u.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        );
      }

      async function fetchData() {
        setLoading(true);
        try {
          const q = await query(
            reservationsRef,
            where("user.email", "==", userInfo.email)
          );
          const data = await getDocs(q);
          const dt = data.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          setData(
            data.docs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
            }))
          );
        } catch (error) {
          setError(error.message);
        }
        setLoading(false);
      }
      fetchData();
      fetchUser();
    }
    
  }, [success, userInfo, navigate]);

  console.log(data);

  return (
    <>
      <NavBar />
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          {loading && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}

          {error && (
            <Typography variant="h6" color="error">
              {error}
            </Typography>
          )}

          {data && (
            <DataGridComponent
              title={"Reservation List"}
              columns={columns}
              rows={
                //where user.email == userInfo.email
                data.filter((doc) => doc.user.email === userInfo.email)
              }
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}
